import React from "react";
import { isCapabilityEnabled } from "../config/capabilities";
import GovFinancialReview from "./FinancialReview";
import CommercialFinancialReview from "./CommercialFinancialReview";

export default function FinancialReviewPage(props) {
  if (isCapabilityEnabled("commercialFinancialReview")) {
    return <CommercialFinancialReview {...props} />;
  }
  return <GovFinancialReview {...props} />;
}
